import { Injectable } from '@angular/core';
import { EncuestaCliente } from '../../models/encuesta-cliente.model';
import { firstValueFrom, map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { SpinnerService } from '../spinner/spinner.service';
import { IServerResponse, ServerResponse } from '../../models/server-response.model';
import { ToastService } from '../toast/toast.service';
import { Respuesta } from '../../models/respuesta.model';

@Injectable({
  providedIn: 'root'
})
export class EncuestaClienteService {

  constructor(
    private http: HttpClient,
    public spinnerService: SpinnerService,
    private toastService: ToastService,
  ) { }

  /* -------------------------------------------------------------------------- */
  /*                                ANCHOR create                               */
  /* -------------------------------------------------------------------------- */
  // region create
  async create(
    idEncuestaCliente: string,
    respuestas: Respuesta[],
  ): Promise<boolean> {

    console.log({respuestas});
    
    let flag = false;

    this.spinnerService.loading = true;
    this.spinnerService.message = 'Enviando respuestas...';

    const urlApi = `${environment.urlApi}/encuestas/${idEncuestaCliente}`;

    try {

      const response = await firstValueFrom(
        this.http.post<IServerResponse<{ encuestaCliente: EncuestaCliente }>>(
          urlApi,
          { respuestas },
          { 
            headers: {
              'Content-Type': 'application/json'
            }
          }
        ).pipe(
          map(res => new ServerResponse<{ encuestaCliente: EncuestaCliente }>(res))
        )
      );

      console.log(response);

      if (response.statusCode === 201) {

        this.spinnerService.loading = false;
        this.spinnerService.message = '';

        this.toastService.show({
          body: response.message,
          classname: 'bg-success text-white'
        });

        console.log(response);
        flag = true;

      } else {

        this.spinnerService.loading = false;
        this.spinnerService.message = '';

      }
    } catch (error) {
      console.log('Error:', error);

      this.spinnerService.loading = false;
      this.spinnerService.message = '';
      
      this.toastService.show({
        header: 'Error al eliminar la respuesta',
        body: `${error}`,
        classname: 'bg-danger text-white'
      });

    }

    // finally {
    //   this.spinnerService.loading = false;
    //   this.spinnerService.message = '';
    // }

    return flag;

  }

  /* -------------------------------------------------------------------------- */
  /*                                 ANCHOR get                                 */
  /* -------------------------------------------------------------------------- */
  // region get
  async get(
    idEncuestaCliente: string
  ): Promise<EncuestaCliente | undefined> {

    let encuestaCliente: EncuestaCliente | undefined;

    this.spinnerService.loading = true;
    this.spinnerService.message = 'Cargando encuesta...';

    const urlApi = `${environment.urlApi}/encuestas/${idEncuestaCliente}`;

    try {

      const response = await firstValueFrom(
        this.http.get<IServerResponse<{ encuestaCliente: EncuestaCliente }>>(
          urlApi,
          { 
            headers: {
              'Content-Type': 'application/json'
            }
          }
        ).pipe(
          map(res => new ServerResponse<{ encuestaCliente: EncuestaCliente }>(res))
        )
      );

      if (response.statusCode === 200) {

        console.log(response);
        

        encuestaCliente = response.data?.encuestaCliente
          ? new EncuestaCliente(response.data.encuestaCliente)
          : undefined;

      }
    } catch (error) {
      console.log('Error:', error);
      
      this.toastService.show({
        header: 'Error al eliminar la respuesta',
        body: `${error}`,
        classname: 'bg-danger text-white'
      });

    }

    finally {
      this.spinnerService.loading = false;
      this.spinnerService.message = '';
    }

    return encuestaCliente;

  }
}
